import { render, staticRenderFns } from "./AnagraficaClienti.vue?vue&type=template&id=700ff15a&scoped=true"
import script from "./AnagraficaClienti.vue?vue&type=script&lang=js"
export * from "./AnagraficaClienti.vue?vue&type=script&lang=js"
import style0 from "./AnagraficaClienti.vue?vue&type=style&index=0&id=700ff15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ff15a",
  null
  
)

export default component.exports